import React, { useEffect, useState } from "react";
import { Moon, Sun, Sunset } from "lucide-react";

const STORAGE_KEY = "elog-maritime-theme";
const THEMES = [
  { id: "day", label: "Day", Icon: Sun },
  { id: "dusk", label: "Dusk", Icon: Sunset },
  { id: "night", label: "Night", Icon: Moon },
];

const getInitialTheme = () => {
  if (typeof window === "undefined") return "day";
  const saved = window.localStorage.getItem(STORAGE_KEY);
  return THEMES.some((item) => item.id === saved) ? saved : "day";
};

export const applyMaritimeTheme = (theme) => {
  if (typeof document === "undefined") return;
  document.documentElement.dataset.maritimeTheme = theme;
};

const MaritimeThemeControl = ({ showLabels = false, className = "" }) => {
  const [theme, setTheme] = useState(getInitialTheme);

  useEffect(() => {
    applyMaritimeTheme(theme);
    window.localStorage.setItem(STORAGE_KEY, theme);
    window.dispatchEvent(new CustomEvent("elog-maritime-theme", { detail: { theme } }));
  }, [theme]);

  return (
    <div className={`maritime-theme-control ${className}`.trim()} aria-label="Display theme">
      {THEMES.map(({ id, label, Icon }) => (
        <button
          key={id}
          type="button"
          className={`maritime-theme-control__button${theme === id ? " is-active" : ""}`}
          onClick={() => setTheme(id)}
          aria-pressed={theme === id}
          title={`${label} display mode`}
        >
          <Icon size={15} aria-hidden="true" />
          {showLabels ? <span className="maritime-theme-control__label">{label}</span> : null}
        </button>
      ))}
    </div>
  );
};

export default MaritimeThemeControl;
